import { Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import StageStatusChip from './StageStatusChip';
import { Ico } from './ui';
import { RT } from '../theme/retentionTheme';

// "Every stage also logs stage status · updated by · updated on" — renders under every stage card,
// without exception (RETENTION_WORKFLOW.md §7). Data comes from retention_stage_progress.
export default function StageAuditFooter({ progress }) {
  return (
    <Stack direction="row" alignItems="center" gap={1.5} flexWrap="wrap">
      <StageStatusChip status={progress?.stage_status ?? 0} />
      <Stack direction="row" alignItems="center" gap={0.5}>
        <Ico icon="solar:user-rounded-linear" size={15} color={RT.faint} />
        <Typography variant="caption" sx={{ color: RT.ink2, fontWeight: 600 }}>
          {progress?.updated_by_name || '—'}
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" gap={0.5}>
        <Ico icon="solar:calendar-linear" size={15} color={RT.faint} />
        <Typography variant="caption" sx={{ color: RT.muted }}>
          {progress?.updated_on ? dayjs(progress.updated_on).format('DD MMM, hh:mm A') : '—'}
        </Typography>
      </Stack>
    </Stack>
  );
}
